import React from 'react';
import { Download16 } from '@carbon/icons-react';
import { CompletionScreen } from 'components/PremiumWizard';

interface CompleteStepProps {
  memberCount?: number;
  isPostpay: boolean;
  transactionReference?: string;
  onDownload: () => void;
  onShare: () => void;
  onLodgeAnother: () => void;
}

const CompleteStep: React.FC<CompleteStepProps> = ({
  memberCount = 127,
  isPostpay,
  transactionReference,
  onDownload
  // onShare,
  // onLodgeAnother
}) => {
  const paymentStat = isPostpay
    ? {
        label: 'Payment',
        value: 'Invoice will be issued',
        valueClassName: 'completion-screen__stat-value--success'
      }
    : {
        label: 'Transaction reference',
        value: transactionReference ?? '—',
        valueClassName: 'byda-member-lookup__completion-transaction-reference'
      };

  return (
    <CompletionScreen
      heading="Your member list is ready!"
      bodyText={`We've found ${memberCount} utility member(s) with infrastructure in your project area.`}
      statsRowClassName={!isPostpay ? 'expand' : undefined}
      stats={[
        { label: 'Member(s) found', value: String(memberCount) },
        paymentStat
      ]}
      primaryAction={{
        label: 'Download member list (CSV)',
        icon: Download16,
        onClick: onDownload
      }}
    />
  );
};

export default CompleteStep;
